<template>
    <div class="devicemanage_class_1">
        <div class="seachtitle ">
            <el-form :inline="true" :model="formInline" label-position="left" class="tableform">
                <!-- <el-form-item label="设备类型：">
                    <el-select v-model="formInline.group_type" placeholder="请选择" size="default" clearable
                        style="width:200px">
                        <el-option v-for="item in deviceTypeList" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item> -->
                <el-form-item label="设备名称：">
                    <el-input size="default" v-model.trim="formInline.deviceName" maxlength="30" placeholder="请输入设备名称"
                        clearable style="width:200px"></el-input>
                </el-form-item>
                <el-form-item label="分厂：">
                    <el-select v-model="formInline.branch_factory" placeholder="请选择" size="default" clearable
                        style="width:200px;">
                        <el-option v-for="item in factoryGroupList" :key="item.id" :label="item.name" :value="item.name">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="工段：">
                    <!-- <el-select v-model="formInline.workSection" placeholder="请选择" size="default" clearable
                        style="width: 200px;">
                        <el-option v-for="item in workSectionList" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select> -->
                    <el-input size="default" v-model.trim="formInline.workshop_section" maxlength="30" placeholder="请输入设备名称"
                      clearable style="width:200px"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button @click="search" type="primary" icon="Search" style="margin-left: 20px;">查询</el-button>
                    <el-button @click="handleEdit('', 'reset')" icon="Refresh" style="margin-right: 10px;">重置</el-button>
                </el-form-item>
               

            </el-form>
        </div>
        <div class="ops_content">
            <el-table  border :data="tableData" ref="tableref"
                v-loading="loadingPage" style="width: 100%;">
                <el-table-column type="index" width="60" align="left" label="序号">
                    <template #default="scope">
                        <span v-text="getIndex(scope.$index)"></span>
                    </template>
                </el-table-column>
                <el-table-column min-width="100" prop="device_name" label="设备名称" 
                    align="left"></el-table-column>
                <el-table-column min-width="100" prop="group_type" label="设备类型" show-overflow-tooltip
                    align="left"></el-table-column>
                <el-table-column min-width="100" prop="branch_factory" label="分厂" show-overflow-tooltip
                    align="left"></el-table-column>
                <el-table-column min-width="100" prop="workshop_section" label="工段" show-overflow-tooltip
                align="left"></el-table-column>
                <el-table-column min-width="100" prop="axis_type" label="轴类型" show-overflow-tooltip
                align="left"></el-table-column>
                <el-table-column min-width="100" prop="name" label="测点名称" show-overflow-tooltip
                    align="left"></el-table-column>
                <el-table-column min-width="100" prop="sn" label="测点ID" show-overflow-tooltip
                align="left"></el-table-column>
                <!-- <el-table-column min-width="100" prop="net" label="网关SN" show-overflow-tooltip
                    align="left">192.168.88.8</el-table-column> -->
                <el-table-column min-width="60" prop="battery" label="电池电量" show-overflow-tooltip
                    align="left"></el-table-column>
                <el-table-column min-width="60" prop="status" label="通讯状态" show-overflow-tooltip
                    align="left"></el-table-column>

            </el-table>


        </div>
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather" ></Pagination>

    </div>
</template>


<script>
import {apiDeviceNumberStatistics,apiDevice,apiSensorlist,apiSensorWithExtra,apiDeviceDelete} from '@/api/api'
import Pagination from "@/components/Pagination";
import deviceTypeConfig from "@/config"
 export default{
    name:'opsManage',
    components:{
            Pagination,
          
        },
    data(){
        return{
         
            treeHighLightFlag:true,
            tableHeight:500,
          
            loadingPage:false,
            showOtherSearch:false,//隐藏过长的搜索条件
            formInline:{
                    group_type: null,
                    deviceName: null,
                    branch_factory:null,
                    workshop_section: null,
            },
            tableData:[],
            deviceTypeList:[
                    {id:0,name:'全部'},
                    {id:1,name:"重点设备"},
                    {id:2,name:"大型机组"},
            ],
            factoryGroupList:[
                    {id:0,name:'全部'},
                    {id:1,name:deviceTypeConfig.DEVICE_TYPE_1},
                    {id:2,name:deviceTypeConfig.DEVICE_TYPE_2},
                    {id:3,name:deviceTypeConfig.DEVICE_TYPE_3},
                    {id:4,name:deviceTypeConfig.DEVICE_TYPE_4},
                    {id:5,name:deviceTypeConfig.DEVICE_TYPE_5},
                    {id:6,name:deviceTypeConfig.DEVICE_TYPE_6},
            ],  
            workSectionList:[
                    {id:0,name:'全部'},
                    {id:1,name:"十六工段"},
                    {id:2,name:"八工段"},
                    {id:3,name:"四工段"},
            ],
            pageparm: {
                    page: 1,
                    page_size: 10,
                    total:1
                },
            fnParm:{
                page: 1,
                page_size: 10,  
            
                ordering:"processed,-time",         
            },
            fntableParm:{
                    page: 1,
                    page_size: 10,
                    ordering:"processed,-time",      
                    group_type : null,
                    branch_factory_exact: null,
                    device_name : null,
                    workshop_section_exact : null     
                },
            route_para :{
                deviceType : 0,
                flag : false ,
            }
        }
    },
    methods:{
          // 表格序列号
          getIndex($index) {
                // (当前页 - 1) * 当前显示数据条数 + 当前行数据的索引 + 1
                return (this.pageparm.page-1)*this.pageparm.page_size + $index +1
            },
            handleEdit(row,flag) {
                let vm = this
                if(flag=='delete') {
                    vm.$confirm('您确定要删除选中的数据吗？' ,{
                        closeOnClickModal:false
                    }).then(res=>{
                        //现在的DELETE命令，通过代理不能收到响应！？                       
                        apiSensorDelete({id:row.id}).then(res=>{
                            this.$message.success("删除传感器成功")
                          
                            vm.search()
                            vm.getTreeData()
                        }) .catch(res => {  
                            console.log(res)
                            this.$message.warning(`删除传感器失败 : ${res.message}`)
                        });

                    }).catch(()=>{

                    })
                }
                else if(flag=="reset"){
                    this.fntableParm = {
                        page:1,
                        page_size: 10,
                        ordering: "-device__status,device__name",
                    }
                    this.pageparm={
                        page: 1,
                        page_size: 10,
                        total: 0
                    }
                    this.treeHighLightFlag = false
                    this.formInline.deviceName = null
                    this.formInline.workshop_section = null
                    this.formInline.group_type = null
                    this.formInline.branch_factory = null
                    this.getData()
                }
            },
            callFather(parm) {
                this.fntableParm.page = parm.page
                this.fntableParm.page_size = parm.page_size
                this.fntableParm.ordering = "processed,-time",
                this.getData()
            },
            search() {
                this.pageparm.page = 1
                this.fntableParm.page = this.pageparm.page
                this.fntableParm.page_size = this.pageparm.page_size
                this.fntableParm.device_name = this.formInline.deviceName
                
                if(this.formInline.branch_factory == null || this.formInline.branch_factory == 0){
                    this.fntableParm.branch_factory_exact = null
                } else{
                    this.fntableParm.branch_factory_exact = this.formInline.branch_factory
                } 
                if(this.formInline.group_type == null || this.formInline.group_type ==0)
                   {
                    this.fntableParm.group_type = null
                   }
                 
                else{
                    this.fntableParm.group_type = this.formInline.group_type
                 }
                  
                if(this.formInline.workshop_section == null || this.formInline.workshop_section ==0)
                {
                    this.fntableParm.workshop_section_exact = null
                }
                    
                else{
                    this.fntableParm.workshop_section_exact = this.formInline.workshop_section
                }                 
                    
              

                this.treeHighLightFlag = false
                this.getData()
            },
            
            dataChange(items){
                this.tableData.length = 0
                for(let i = 0;i<items.length;i++){
                    this.tableData[i] = items[i]
                    switch(items[i].group_type){
                        case 1:  this.tableData[i].group_type="重点设备" ;break;
                        case 2:  this.tableData[i].group_type="大型机组";break;
                        default: this.tableData[i].group_type="未知" ;break;
                    }
                    switch(items[i].status){
                        case 0:  this.tableData[i].status="NA" ;break;
                        case 1:  this.tableData[i].status="健康" ;break;
                        case 2:  this.tableData[i].status="故障" ;break;
                        case 3:  this.tableData[i].status="停机" ;break;
                        case 4:  this.tableData[i].status="离线" ;break;
                        default: this.tableData[i].status="未知" ;break;
                    } 
                    if(this.tableData[i].type ==1){
                        switch(items[i].axis_type){
                        case 1:  this.tableData[i].axis_type="单轴" ;break;
                        case 3:  this.tableData[i].axis_type="三轴";break;
                        default: this.tableData[i].axis_type="未知" ;break;
                    }
                    }else{
                        this.tableData[i].axis_type = '--'
                    }
                    this.tableData[i].battery =  (items[i].battery*100).toFixed(1) +'%'           
                    
                }       
            },
            getData(){
                this.loadingPage = true
                this.tableData.length = 0;

                apiSensorlist(this.fntableParm).then(res => {
                    this.loadingPage = false
                    if(res.data.code ==200) {
                        this.dataChange(res.data.data.items)
                        this.pageparm.total = res.data.data.total;
                        let { page, page_size } = res.config.params 
                        this.pageparm.page = page    
                        this.pageparm.page_size = page_size  
                    }else{
                        this.$message.error(res.data.msg)
                    }
                 }) .catch(res => {  
                    this.loadingPage = false
                    this.$message.warning(`获取传感器信息失败 : ${res.msg}`)
                });  
            },
            listenResize() {
				this.$nextTick(() => {
				    
				})
			},
         

            
    },
    mounted() {
            // 监听页面宽度变化搜索框的高度
            window.addEventListener('resize', this.listenResize);
            this.$nextTick(() => {
                this.getData()
            })
        },
    unmounted() {
            // 页面销毁，去掉监听事件
        window.removeEventListener("resize", this.listenResize);
    },
    // created() {
    //     if(this.$route.query.type){
    //         this.route_para.deviceType = this.$route.query.type
    //         this.route_para.flag = true
    //         this.formInline.deviceType = parseInt(this.route_para.deviceType)
    //     } else {
    //         this.route_para.flag = false
    //     } 

     
    //     if(this.route_para.flag){
    //         this.fntableParm = {
    //             page : this.pageparm.page,
    //             page_size : this.pageparm.page_size,
    //             device_type : this.route_para.deviceType,
              
    //         }
    //     }else{
    //         this.fntableParm = {
    //             page : this.pageparm.page,
    //             page_size : this.pageparm.page_size,
                
    //         }                
    //     } 
    //     this.getData()
    // },
    
 }


</script>
<style lang="scss" scoped>
 .devicemanage_class_1{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: calc(100vh * 0.85);
    background: url("@/assets/bigscreen/block_bg.jpg") no-repeat;
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
    padding: 20px;
    .seachtitle{
        width: 100%;
       
        .tableform{
            padding: 0px;
           
        }
    }
    .ops_content{
      
        width: 100%;
        height: 100%;
        .el-table{
            height: 100%;
        }
        overflow: auto;
    }
   
 }
</style> 